var _rect, _path, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.691406,
    y: 0.00012207,
    width: 24,
    height: 24.0001,
    rx: 2.82353
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.90453 4.22344C7.90453 3.84021 8.21741 3.52954 8.60338 3.52954C8.98935 3.52954 9.30224 3.84021 9.30224 4.22344V5.03755H16.0897V4.22344C16.0897 3.84021 16.4026 3.52954 16.7886 3.52954C17.1746 3.52954 17.4874 3.84021 17.4874 4.22344V5.03755H18.3384C19.8977 5.03755 21.1619 6.29274 21.1619 7.84109V9.25665V10.6446V17.6672C21.1619 19.2156 19.8977 20.4708 18.3384 20.4708H7.04423C5.48484 20.4708 4.2207 19.2156 4.2207 17.6672V10.6446V9.25665V7.84109C4.2207 6.29274 5.48484 5.03755 7.04423 5.03755H7.90453V4.22344ZM16.0897 6.43932V7.14804C16.0897 7.53127 16.4026 7.84194 16.7886 7.84194C17.1746 7.84194 17.4874 7.53127 17.4874 7.14804V6.43932H18.3384C19.118 6.43932 19.7501 7.06691 19.7501 7.84109V9.24286H5.63247V7.84109C5.63247 7.06691 6.26454 6.43932 7.04423 6.43932H7.90453V7.14804C7.90453 7.53127 8.21741 7.84194 8.60338 7.84194C8.98935 7.84194 9.30224 7.53127 9.30224 7.14804V6.43932H16.0897ZM5.63247 10.6584H19.7501V17.6672C19.7501 18.4414 19.118 19.069 18.3384 19.069H7.04423C6.26454 19.069 5.63247 18.4414 5.63247 17.6672V10.6584Z",
    fill: "#143678"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.21855,
    cy: 13.3515,
    r: 1.01152,
    fill: "#006560"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.1756,
    cy: 13.3515,
    r: 1.01152,
    fill: "#006560"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.1326,
    cy: 13.3515,
    r: 1.01152,
    fill: "#006560"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.0896,
    cy: 13.3515,
    r: 1.01152,
    fill: "#006560"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.21855,
    cy: 16.3746,
    r: 1.01152,
    fill: "#006560"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.1756,
    cy: 16.3746,
    r: 1.01152,
    fill: "#006560"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.1326,
    cy: 16.3746,
    r: 1.01152,
    fill: "#006560"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.0896,
    cy: 16.3746,
    r: 1.01152,
    fill: "#006560"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/Calendar.1a01df39e78da1f97d3e8db5eeb0b225.svg";
export { ForwardRef as ReactComponent };